import React from 'react';
import { Link } from 'react-router-dom';
import '../style/LobbyList.css';
import { useLobbyListController } from '../controllers/useLobbyListController.js';

function LobbyList() {
    const {
        lobbies, loading, error,
        name, setName,
        password, setPassword,
        showNameDialog, setShowNameDialog,
        selectedLobby, handleJoinLobby, handleNameSubmit,
        fetchLobbies
    } = useLobbyListController();

    return (
        <div className="container">
            <div className="box lobby-list-container">
                <div className="lobby-list-header">
                    <div className="page-icon-header" style={{ marginBottom: 0 }}>
                        <div className="page-icon page-icon--browse">
                            <i className="fas fa-list" />
                        </div>
                    </div>
                    <h1>Aktive Lobbys</h1>
                    <div className="page-divider">
                        <span className="page-divider-line" />
                        <span className="page-divider-diamond" />
                        <span className="page-divider-line" />
                    </div>
                    <button
                        className="refresh-icon-button"
                        onClick={fetchLobbies}
                        disabled={loading}
                        title="Lobbyliste aktualisieren"
                    >
                        <span className={`refresh-icon ${loading ? 'spinning' : ''}`}>↻</span>
                    </button>
                </div>

                {loading ? (
                    <p>Lobbys werden geladen...</p>
                ) : error ? (
                    <p className="error-message">{error}</p>
                ) : lobbies.length === 0 ? (
                    <p>Aktuell sind keine Lobbys aktiv.</p>
                ) : (
                    <div className="lobbies-grid">
                        {lobbies.map((lobby) => (
                            <div
                                key={lobby.code}
                                className={`lobby-card lobby-card--${lobby.status === 'started' ? 'started' : 'waiting'}`}
                            >
                                <div className="lobby-details">
                                    <h3>
                                        {lobby.code}
                                        {lobby.isPrivate && (
                                            <span className="private-badge" title="Private Lobby">
                                                <i className="fas fa-lock"></i>
                                            </span>
                                        )}
                                    </h3>
                                    <p style={{ margin: '4px 0', fontSize: '0.85rem', color: 'rgba(200,200,220,0.7)' }}>
                                        <i className="fas fa-users" style={{ marginRight: 6 }} />
                                        {lobby.userCount} Spieler
                                    </p>
                                    <span className={`lobby-status-badge lobby-status-badge--${lobby.status === 'started' ? 'started' : 'waiting'}`}>
                                        <i className={`fas ${lobby.status === 'started' ? 'fa-gamepad' : 'fa-hourglass-half'}`} />
                                        {lobby.status === 'started' ? 'Spiel läuft' : 'Wartet'}
                                    </span>
                                </div>
                                <button
                                    className="button button-primary"
                                    onClick={() => handleJoinLobby(lobby)}
                                    disabled={lobby.status === 'started'}
                                >
                                    {lobby.status === 'started' ? 'Spiel läuft' : 
                                     lobby.isPrivate ? 'Privater Lobby beitreten' : 'Beitreten'}
                                </button>
                            </div>
                        ))}
                    </div>
                )}

                <div className="button-group">
                    <Link to="/create">
                        <button className="button button-primary">Neue Lobby erstellen</button>
                    </Link>
                    <Link to="/">
                        <button className="button button-secondary">Zurück</button>
                    </Link>
                </div>
            </div>

            {/* Name-Dialog */}
            {showNameDialog && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>Lobby beitreten</h2>
                        <p>
                            {selectedLobby?.isPrivate 
                                ? 'Gib deinen Namen und das Lobby-Passwort ein' 
                                : 'Gib deinen Namen ein'}
                        </p>

                        <form onSubmit={handleNameSubmit}>
                            <div className="form-group">
                                <label htmlFor="player-name">Name:</label>
                                <input
                                    type="text"
                                    id="player-name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    maxLength={20}
                                    autoFocus
                                    placeholder="Dein Spielername"
                                />
                            </div>

                            {selectedLobby?.isPrivate && (
                                <div className="form-group">
                                    <label htmlFor="lobby-password">Passwort:</label>
                                    <input
                                        type="password"
                                        id="lobby-password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Lobby-Passwort"
                                    />
                                </div>
                            )}

                            <div className="button-group">
                                <button
                                    type="button"
                                    className="button button-secondary"
                                    onClick={() => {
                                        setShowNameDialog(false);
                                        setName('');
                                        setPassword('');
                                    }}
                                >
                                    Abbrechen
                                </button>
                                <button
                                    type="submit"
                                    className="button button-primary"
                                    disabled={!name.trim() || (selectedLobby?.isPrivate && !password.trim())}
                                >
                                    Beitreten
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default LobbyList;
